import { useCallback, useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import type {
  PcmpMarketingBatchesParams,
  PcmpMarketingBatchSearch,
} from '../types/pcmpMarketing.types';
import { usePcmpQueueFilters } from './usePcmpQueueFilters';

const route = getRouteApi('/_auth/pcmp/marketing/batches/$batchNo/');

/** A Marketing batch's drill-down: the queue filters and paging. */
export function usePcmpMarketingBatchFilters() {
  const { batchNo } = route.useParams();
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const setSearch = useCallback(
    (update: (prev: PcmpMarketingBatchSearch) => PcmpMarketingBatchSearch) => {
      void navigate({ search: update });
    },
    [navigate],
  );

  const queue = usePcmpQueueFilters(search, setSearch);
  const { appliedFilters, page, limit } = queue;

  const params = useMemo<PcmpMarketingBatchesParams>(
    () => ({ ...appliedFilters, page, limit }),
    [appliedFilters, page, limit],
  );

  return { ...queue, batchNo, params };
}
